import { ref } from 'vue';
import type { Ref } from 'vue';
import type { ComponentExposed } from 'vue-component-type-helpers';

export class DadosLogisticosTabClass {
	visible = ref<boolean>(true);
	inputEmbalagemRef: Ref<ComponentExposed<unknown> | null> = ref(null);
}